<aside ui-view="leftbar" class="hidden-sm hidden-xs hidden-md col-lg-2 col-xl-3"></aside>
<div ui-view="dmsmain" class="col-sm-12 col-md-12 col-lg-10 col-xl-9"></div>